// src/utils/logAccessClient.js
//
// Registra ogni apertura del gestionale chiamando la Cloud Function
// "logAccess" (vedi functions/index.js). Tutto interno al progetto Firebase
// esistente: nessun servizio esterno (no Google Analytics, no Cloudflare, ecc).
//
// Uso, dentro AdminDashboard.js (dove companyId è già disponibile):
//
//   import { logAccess } from '../utils/logAccessClient';
//   useEffect(() => { if (companyId) logAccess(companyId); }, [companyId]);

import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

const logAccessFn = httpsCallable(functions, 'logAccess');

export function logAccess(companyId) {
  // fire-and-forget: non deve mai bloccare né rompere il rendering della pagina
  logAccessFn({ path: window.location.pathname, companyId: companyId || null }).catch(() => {
    // silenzioso: un fallimento nel log non deve impattare l'esperienza utente
  });
}
